import { FlowGrid, Row, Separator, useContainerWidth, colors, Overline, Subheading, H2, H4 } from '@fs/zion-ui'
import { useTranslation, Trans } from 'react-i18next'
import React from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import { PillButton } from '../buttons'
import { circlesFireJpg, circlesSeafoamJpg } from '../../images'
import { cventConfig, FLAGS, registrationConfig } from '../../config'
import { BorderCard } from '../card'

const { attendeePricing } = registrationConfig

const PricingCard = ({ title, overline, heading, subHeading, to, linkName, src, flavor, buttonText }) => {
  return (
    <BorderCard backgroundImage={src} topHeading={title} flavor={flavor} hideDivider as="h3">
      <Separator />
      <H4 size="H2" centered>
        <Overline>{overline}</Overline>
        {heading}
        <Separator size="xxs" />
        <Subheading>{subHeading}</Subheading>
      </H4>
      <Separator size="sm" />
      <Row alignX="center">
        <PillButton to={to} linkName={linkName} target="_blank" noPrependLocaleCode>
          {buttonText}
        </PillButton>
      </Row>
      <Separator />
    </BorderCard>
  )
}

export default function PricingCards() {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const earlyBirdPricingFlag = useFeatureFlag(FLAGS.EARLY_BIRD_PRICING)
  const { promo, standard } = attendeePricing

  return (
    <>
      <H2 size="H3" centered>
        {t('in-person.pricing.2024', '2026 In-Person Pricing')}
        <Separator size="xxs" />
        <Subheading>
          {t(
            'in-person.pricing.subheading',
            'Come to Salt Lake City to experience 250+ exclusive sessions and develop new friendships and reunite with old friends.'
          )}
        </Subheading>
      </H2>
      <Separator />
      <FlowGrid columnCount={atWidth({ default: 1, md: 2 })}>
        <PricingCard
          src={circlesFireJpg}
          title={t('in-person.pricing.3-day-pass', '3-Day Pass')}
          overline={
            earlyBirdPricingFlag.isOn
              ? t('in-person.pricing.early-bird.three-day', 'Early Bird Price – Save $30')
              : '\u00A0'
          }
          heading={
            <Trans
              i18nKey="in-person.pricing.price"
              // eslint-disable-next-line no-template-curly-in-string
              defaults="${price} <S>US</S>"
              values={{ price: earlyBirdPricingFlag.isOn ? promo.threeDay : standard.threeDay }}
              components={{ S: <span style={{ color: colors.gray50 }} /> }}
            />
          }
          subHeading={
            earlyBirdPricingFlag.isOn && (
              <Trans
                i18nKey="in-person.pricing.3-day-standard-price"
                defaults="<S>$129</S> Standard Price"
                components={{ S: <s /> }}
              />
            )
          }
          to={cventConfig.registrationUrl}
          linkName="Registration: 3-day-pass"
          flavor="mango"
          buttonText={t('in-person.pricing.get-3-day-pass', 'Get 3-Day Pass')}
        />
        <PricingCard
          src={circlesSeafoamJpg}
          title={t('in-person.pricing.1-day-pass', '1-Day Pass')}
          overline={
            earlyBirdPricingFlag.isOn
              ? t('in-person.pricing.early-bird.one-day', 'Early Bird Price – Save $10')
              : '\u00A0'
          }
          heading={
            <Trans
              i18nKey="in-person.pricing.price"
              // eslint-disable-next-line no-template-curly-in-string
              defaults="${price} <S>US</S>"
              values={{ price: earlyBirdPricingFlag.isOn ? promo.oneDay : standard.oneDay }}
              components={{ S: <span style={{ color: colors.gray50 }} /> }}
            />
          }
          subHeading={
            earlyBirdPricingFlag.isOn && (
              <Trans
                i18nKey="in-person.pricing.1-day-standard-price"
                defaults="<S>$79</S> Standard Price"
                components={{ S: <s /> }}
              />
            )
          }
          to={cventConfig.registrationUrl}
          linkName="Registration: 1-day-pass"
          flavor="fire"
          buttonText={t('in-person.pricing.get-1-day-pass', 'Get 1-Day Pass')}
        />
      </FlowGrid>
    </>
  )
}
